'use client';

import { useEffect, useState } from 'react';

// Client-side poster with graceful fallback (external images may 404 or be slow).
export default function Poster({
  src,
  alt,
  className,
}: {
  src: string;
  alt: string;
  className?: string;
}) {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [src]);

  if (!src || failed) {
    return (
      <div
        className={`${className || ''} bg-gradient-to-br from-zinc-800 to-zinc-900 flex items-center justify-center`}
      >
        <span className="text-3xl font-black text-zinc-600">A</span>
      </div>
    );
  }
  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src={src}
      alt={alt}
      loading="lazy"
      referrerPolicy="no-referrer"
      onError={() => setFailed(true)}
      className={className}
    />
  );
}
